// Asks the user for a reason when a source screen (Sales, Purchase, Returns, Loans) changes
// something that belongs to a closed day. Resolves with the reason text, or null if cancelled.
import React from 'react';
import { Modal, Input } from 'antd';

let pending = null; // only one prompt at a time

const askClosedDayReason = (dateText) => {
  if (pending) return pending;
  pending = new Promise((resolve) => {
    let value = '';
    let modal;
    const body = (err) => (
      <div>
        <p style={{ marginBottom: 8 }}>
          {dateText ? `${dateText} is closed.` : 'This day is closed.'} Please enter the reason for this change. It
          will be recorded in the audit log.
        </p>
        <Input.TextArea
          rows={3}
          maxLength={500}
          autoFocus
          placeholder="Reason for change"
          onChange={(e) => {
            value = e.target.value;
          }}
          style={{ resize: 'none' }}
        />
        {err && <div style={{ color: '#ef4444', marginTop: 6 }}>A reason is required</div>}
      </div>
    );
    modal = Modal.confirm({
      title: 'Change on a closed day',
      content: body(false),
      okText: 'Continue',
      cancelText: 'Cancel',
      onOk: () => {
        if (!value.trim()) {
          modal.update({ content: body(true) });
          return Promise.reject(new Error('reason required'));
        }
        resolve(value.trim());
      },
      onCancel: () => resolve(null),
    });
  }).finally(() => {
    pending = null;
  });
  return pending;
};

export default askClosedDayReason;
